import { Component, EventEmitter, Injectable, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { WidgetDateV0Utils } from './widget-date-v0.utils';
import { IoniconsOutline } from '@pt/pt-models';
import { WidgetUtils } from '../../widget.utils';


@Injectable()
export class CustomAdapter extends NgbDateAdapter<number> {
  fromModel(value: number | null): NgbDateStruct | null {
    if (value) {
      return WidgetDateV0Utils.timestampToNgbDateStruct(value);
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): number | null {
    return WidgetDateV0Utils.ngbDateStructToTimestamp(date);
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      const response = {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
      return response;
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    const response = date ? date.day.toString().padStart(2, '0') + this.DELIMITER + date.month.toString().padStart(2, '0') + this.DELIMITER + date.year : '';
    return response;
  }
}

@Component({
  selector: 'pt-widget-date-v0-edit',
  template: `
    <ng-container *ngIf='show'>
      <div class="input-group pt-widget-date-v0-edit">
        <input
          class="form-control input-calendar"
          aria-describedby="dateHelp"
          [ngClass]="{'is-invalid': !validDate}"
          placeholder="dd/MM/yyyy"
          container="body"
          name="d2"
          [(ngModel)]="modelDate"
          (ngModelChange)="changeTimestampValue($event)"
          ngbDatepicker
          #d2="ngbDatepicker" />

        <button class="btn btn-outline-secondary btn-calendar"
                (click)="d2.toggle()" type="button">
          <pt-icon class="d-flex" [key]='IconCalendar' [size]='16'></pt-icon>
        </button>
      </div>
    </ng-container>
    <!--    <small id="dateHelp" class="form-text text-muted" *ngIf="!validDate">Invalid date.</small>-->

  `,
  styles: [
    `
      .input-calendar {
        height: 25px;
        border-radius: 0;
        font-size: 0.875rem;
      }

      .btn-calendar {
        padding: 0 10px;
        height: 25px;
        border-radius: 0;
        display: flex;
        align-items: center;
        /*background: #e9ecef;*/
      }

      .pt-widget-date-v0-edit {
        width: 235px;
      }

      .pt-widget-date-v0-edit input {
        background: white;
      }
    `
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class WidgetDateV0EditComponent implements OnChanges {
  @Input() date: number;
  @Input() show: boolean;
  @Output() changeDate: EventEmitter<WidgetDateOutput> = new EventEmitter<WidgetDateOutput>();
  public id = WidgetUtils.generateId('widget_date_');
  public IconCalendar = IoniconsOutline.calendarCheck;
  public IconClose = IoniconsOutline.close;
  public modelDate: number;
  public validDate = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.date) {
      this.intValue();
    }
  }

  changeTimestampValue($event: number) {

    if (Number.isSafeInteger($event) && $event > 0) {
      this.validDate = true;
      const r: WidgetDateOutput = {
        timestamp: $event,
        error: false,
      }
      this.changeDate.emit(r);
    } else {
      this.validDate = false;
      const r: WidgetDateOutput = {
        timestamp: null,
        error: $event !== null && $event !== undefined
      }
      this.changeDate.emit(r);
    }
  }

  intValue() {
    this.modelDate = this.date ? JSON.parse(JSON.stringify(this.date)) : null;
    this.changeTimestampValue(this.modelDate);
  }
}

export interface WidgetDateOutput {
  timestamp: number;
  error: boolean;
}
